<template>
  <BaseCard class="ce-available-balance-card flex column align-center justify-center">
    <p class="value flex">{{ formattedBalance }}</p>
    <p class="label flex">SALDO</p>
  </BaseCard>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseCard from '@/components/BaseCard'

export default {
  name: 'CEAvailableBalanceCard',
  components: {
    BaseCard
  },
  computed: {
    ...mapGetters(['formattedBalance'])
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants';

.ce-available-balance-card {
  background-color: $purple;
  color: $white;
  width: 18%;
  height: 11rem;
}

.value {
  font-size: 2rem;
}

.label {
  font-size: 1rem;
  font-weight: 600;
}

@media(max-width: 90rem) {
  .ce-available-balanace-card {
    height: 12rem;
  }

  .label {
    font-size: 1rem;
  }
}

@media (max-width: 30rem) {
  .ce-available-balance-card {
    width: 100%;
    margin-bottom: 6%;
  }
}
</style>
